<form class="w-100 h-100 form" [formGroup]="cardForm" (ngSubmit)="sendData()">
  <h4 class="text-center"> {{cardInfo.id ? 'Editar': 'Nuevo'}}  Card</h4>
  <div class="row mx-0 my-3 p-0 w-100" style="  max-height: 430px; overflow-y: auto;">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img ng-star-inserted menu-img mb-4" [src]="fileImg64 | safeDom" alt="img-banner" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de 200px x 150px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event)" />
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="my-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título</mat-label>
          <input matInput placeholder="Título" formControlName="title" required>
          <mat-hint align="end">CONSULTA EL ESTADO DE TU REQUERIMIENTO O RECLAMO</mat-hint>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3 text-center">
      <div class="mb-3">
        <div>
          <h5 class="fw-bold m-0">Columna</h5>
        </div>
        <mat-button-toggle-group formControlName="column" aria-label="order" [value]="cardForm.value.column">
          <mat-button-toggle [value]="1" (click)="changeColumn(1)">1</mat-button-toggle>
          <mat-button-toggle [value]="2" (click)="changeColumn(2)">2</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div class="col-2">
      <div class="mb-3">
        <div>
          <h5 class="fw-bold m-0">Orden</h5>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select formControlName="order" required>
<!--            <mat-option [value]="cardInfo.orderId">{{cardInfo.orderId}}</mat-option>-->
            <mat-option *ngFor="let cards of cardsOrder; index as i" [value]=" i + 1">{{i + 1}}</mat-option>
          </mat-select>
<!--          <input matInput type="number" placeholder="Orden" formControlName="order" required>-->
<!--          <mat-error>Este campo es <b>Requerido</b></mat-error>-->
        </mat-form-field>
<!--        <mat-button-toggle-group formControlName="order" aria-label="order" [value]="cardForm.value.order">-->
<!--          <mat-button-toggle [value]="1">1</mat-button-toggle>-->
<!--          <mat-button-toggle [value]="2">2</mat-button-toggle>-->
<!--          <mat-button-toggle [value]="3">3</mat-button-toggle>-->
<!--        </mat-button-toggle-group>-->
      </div>
    </div>
    <div class="col-12 mb-3">
      <div>
        <h5 class="fw-bold m-0">Tipo de card</h5>
      </div>
      <mat-button-toggle-group formControlName="typeId" aria-label="order">
        <mat-button-toggle [value]="2" (click)="setUrl()">Url</mat-button-toggle>
        <mat-button-toggle [value]="1" (click)="setFormCard()">Formulario</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="col-12" *ngIf=" cardType === 2 ">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Url</mat-label>
        <input matInput placeholder="Url" formControlName="url">
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
<!--    <div class="col-12 mb-3" *ngIf="cardType === 2 || cardForm.value.typeId === 2">-->
<!--      <div>-->
<!--        <h5 class="fw-bold m-0">¿Tipo Botón?</h5>-->
<!--      </div>-->
<!--      <mat-button-toggle-group formControlName="activeButton" aria-label="activeButton" [value]="cardForm.value.activeButton">-->
<!--        <mat-button-toggle [value]="1" (click)="isThisButton = true">Si</mat-button-toggle>-->
<!--        <mat-button-toggle [value]="0" (click)="setButtonNull()">No</mat-button-toggle>-->
<!--      </mat-button-toggle-group>-->
<!--    </div>-->
<!--    <div class="col-12" *ngIf="isThisButton || cardForm.value.activeButton === 1">-->
<!--      <mat-form-field appearance="outline" class="w-100">-->
<!--        <mat-label>Texto de boton</mat-label>-->
<!--        <input matInput placeholder="Texto de boton" formControlName="nameButton">-->
<!--        <mat-error>Este campo es <b>Requerido</b></mat-error>-->
<!--      </mat-form-field>-->
<!--    </div>-->
    <div class="col-12" *ngIf="cardType !== 1">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Contenido</mat-label>
          <textarea matInput #content placeholder="Contenido" [maxLength]="maxLength" formControlName="subTitle" rows="4"> </textarea>
          <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="cardForm.invalid">
      Guardar
    </button>
  </div>
</form>
